export default "__VITE_ASSET__CdUIN4$n__"